import Swal, { SweetAlertIcon } from 'sweetalert2';
import i18n from '../localization';
import variable from './style/variable';

export const toastAlert = (icon: SweetAlertIcon, title: string, text?: string) =>
    Swal.fire({
        title,
        text,
        icon,
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 2000,
    });

export const dialogAsync = (icon: SweetAlertIcon, title: string, text: string, callback: () => void) =>
    Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonColor: variable.green,
        cancelButtonColor: variable.red,
        confirmButtonText: i18n.t('yes'),
        cancelButtonText: i18n.t('cancel'),
    }).then(async result => {
        if (result.isConfirmed) {
            callback();
        }
    });

export const dialog = (icon: SweetAlertIcon, text?: string) =>
    Swal.fire({
        text,
        icon,
        timer: 10000,
    });
